import { createAction, props } from '@ngrx/store';
import { QRTemplate, QRTemplatesListMeta } from '../models/qr-template.model';
import { QRTemplateDetail, CreateQRTemplatePayload, UpdateQRTemplatePayload } from '../models/qr-template-detail.model';

export const loadQRTemplates = createAction(
  '[QR Templates] Load QR Templates',
  props<{ page?: number; perPage?: number; search?: string; sort?: string; sortDirection?: string }>()
);
export const loadQRTemplatesSuccess = createAction(
  '[QR Templates] Load QR Templates Success',
  props<{ qrTemplates: QRTemplate[]; meta: QRTemplatesListMeta }>()
);
export const loadQRTemplatesFailure = createAction(
  '[QR Templates] Load QR Templates Failure',
  props<{ error: string }>()
);

export const resetQRTemplatesState = createAction('[QR Templates] Reset State');

// Load single QR template
export const loadQRTemplate = createAction(
  '[QR Template Drawer] Load QR Template',
  props<{ uuid: string }>()
);
export const loadQRTemplateSuccess = createAction(
  '[QR Template Drawer] Load QR Template Success',
  props<{ template: QRTemplateDetail }>()
);
export const loadQRTemplateFailure = createAction(
  '[QR Template Drawer] Load QR Template Failure',
  props<{ error: string }>()
);

// Create QR template
export const createQRTemplate = createAction(
  '[QR Template Drawer] Create QR Template',
  props<{ payload: CreateQRTemplatePayload }>()
);
export const createQRTemplateSuccess = createAction(
  '[QR Template Drawer] Create QR Template Success',
  props<{ template: QRTemplateDetail }>()
);
export const createQRTemplateFailure = createAction(
  '[QR Template Drawer] Create QR Template Failure',
  props<{ error: string }>()
);

// Update QR template
export const updateQRTemplate = createAction(
  '[QR Template Drawer] Update QR Template',
  props<{ uuid: string; payload: UpdateQRTemplatePayload }>()
);
export const updateQRTemplateSuccess = createAction(
  '[QR Template Drawer] Update QR Template Success',
  props<{ template: QRTemplateDetail }>()
);
export const updateQRTemplateFailure = createAction(
  '[QR Template Drawer] Update QR Template Failure',
  props<{ error: string }>()
);

// Delete QR template
export const deleteQRTemplate = createAction(
  '[QR Template Drawer] Delete QR Template',
  props<{ uuid: string }>()
);
export const deleteQRTemplateSuccess = createAction(
  '[QR Template Drawer] Delete QR Template Success',
  props<{ uuid: string }>()
);
export const deleteQRTemplateFailure = createAction(
  '[QR Template Drawer] Delete QR Template Failure',
  props<{ error: string }>()
);

// Reset current template
export const resetCurrentQRTemplate = createAction('[QR Template Drawer] Reset Current Template');
